import AddMatcherPage from './AddMatcherPage';

export default AddMatcherPage;
